/**
 * SuccessCelebration.jsx - Success celebration modal component
 * Shows animated celebration when simulation completes
 * Extracted from Simulations.jsx
 */
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, PartyPopper, BarChart3 } from 'lucide-react';

const SuccessCelebration = ({ isVisible, simulationName, onClose }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(onClose, 4000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/80 backdrop-blur-sm animate-fade-in">
      <div className="text-center space-y-6 animate-scale-in relative">
        <button 
          onClick={onClose}
          className="absolute -top-2 -right-2 p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
        >
          <X className="w-4 h-4 text-white" />
        </button>
        <div className="relative">
          <div className="w-24 h-24 mx-auto rounded-full bg-gradient-to-br from-emerald-400 to-emerald-500 flex items-center justify-center animate-bounce">
            <PartyPopper className="w-12 h-12 text-white" />
          </div>
          <div className="absolute -top-2 -left-2 w-6 h-6 text-2xl animate-ping">🎉</div>
          <div className="absolute -top-2 -right-2 w-6 h-6 text-2xl animate-ping" style={{animationDelay: '0.2s'}}>✨</div>
          <div className="absolute -bottom-2 left-4 w-6 h-6 text-2xl animate-ping" style={{animationDelay: '0.4s'}}>🎊</div>
        </div>
        <div>
          <h3 className="text-2xl font-bold text-white">Simulation Complete!</h3>
          <p className="text-emerald-200 mt-2 text-lg">{simulationName}</p>
          <p className="text-slate-400 mt-1">Results are ready to view</p>
        </div>
        <Link 
          to={`/analysis`}
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary hover:bg-primary/90 text-white rounded-lg font-medium transition-colors"
        >
          <BarChart3 className="w-5 h-5" />
          View Results
        </Link>
      </div>
    </div>
  );
};

export default SuccessCelebration;
